import { useSelector } from 'react-redux'
import { DriverPerformance } from 'shared/components/DriverMetrics/DriverPerformance'

import { currentUserSelector } from '../../redux/selectors/users'

export function MyPerformance() {
  const user = useSelector(currentUserSelector)
  return (
    <div className="p-5">
      <DriverPerformance id="me" actorKey={user.id} jobHref={(id) => `/jobs/details/${id}/`} />
    </div>
  )
}
